
const initState = {
  data:{},
  tasks:{},
  actions:[],
  tariffs:[],
  invoice:{}
}

const requestReducer = (state = initState, action) =>{
  switch (action.type) {
    case 'SET_DATA' :
      return {...state, data: action.payload}
    case 'SET_ALL_DATA' :
      return {...state, tasks: action.payload}
    case 'SET_STATUS' :
      return {...state, data: {...state.data, status: action.payload}}
    case 'SET_ACTION' :
      return {...state, actions: actions.push(action.payload)}
    case 'SET_ACTION' :
      return {...state, tariffs: action.payload}
    case 'SET_INVOICE' :
      return {...state, invoice: action.payload}
    default:{
      return state;
    }
  }
}

export default requestReducer;
